export const PROMOTION_CODES = {
    PRM009: 'DISCOUNTED_PROMOTION_SHOULD_HAVE_DATE_RAGE',
    PRM007: 'PROMOTION_CATEGORY_ALREADY_EXISTS',
    PRM011: 'DISCOUNTED_PROMOTION_CANNOT_START_IN_PAST',
    PRM005: 'PRODUCT_ALREADY_IN_PROMOTION',
};
